import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import useWarehousesLoading from 'hooks/useWarehousesLoading'
import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import MagResignation from './resignation/Termination'
import useTranslation from 'hooks/useTranslation'
import RentalExtension from './RentalExtension'
import MagAccessories from './MagAccessories'
import MagNumber from 'components/MagNumber'
import MagCancel from './resignation/Cancel'
import Invoices from '../Account/Invoices'
import { isMobile } from 'utils/isMobile'
import { useReduxSelector } from 'store'
import MagDetails from './MagDetails'
import MagHistory from './MagHistory'
import MagAccess from './MagAccess'
import { SECTION_TYPES } from '.'

const mobile = isMobile()

const SubMenu: React.FC = () => {
  const [goodbye, setGoodbye] = useState(0)
  const { type, id } = useParams<warehouse.PageParams>()
  const { name, contractId, isShared, acronym } = useReduxSelector(state => selectWarehouse(state, id))
  useWarehousesLoading(!contractId)

  const listRef = useRef<HTMLDivElement>(null)
  const menuRef = useRef<HTMLDivElement>(null)

  const { goBack, replace } = useHistory()
  const { t } = useTranslation('warehouse')

  useEffect(() => {
    if (mobile) {
      document.body.style.setProperty('overflow', 'hidden')
      return () => {
        document.body.style.removeProperty('overflow')
      }
    }
  }, [])

  const onTouch = (e: React.TouchEvent<HTMLElement>) => {
    const list = listRef.current
    const menu = menuRef.current
    if (!list || !menu) return

    let updateState = true
    const { scrollTop } = list
    const initialY = e.touches[0].clientY

    const touchMove = (e: TouchEvent) => {
      const currentY = e.touches[0].clientY
      const difference = currentY - initialY
      updateState = difference < 80
      if (updateState) setGoodbye(difference > 0 ? Number((difference / 50).toFixed(1)) : 0)
    }

    const touchEnd = () => {
      updateState ? setGoodbye(0) : back()
      menu.removeEventListener('touchend', touchEnd, false)
      menu.removeEventListener('touchmove', touchMove, false)
    }

    if (scrollTop < 1) {
      menu.addEventListener('touchend', touchEnd, false)
      menu.addEventListener('touchmove', touchMove, false)
    }
  }

  const back = () => window.history ? goBack() : replace('/warehouse')

  return (
    <div
      className='warehouse'
      style={{ overflow: 'hidden' }}>

      <div className='warehouse__main'>
        <MagNumber
          number={name}
          isShared={isShared}
          acronym={acronym}
        />
      </div>

      <div
        ref={menuRef}
        style={{ top: isShared ? 15 : 0 }}
        className='menu__main'
        onTouchStart={onTouch}>

        <div className='menu__status --noShadow'>
          <div className='line' />
          {(type === SECTION_TYPES.invoices || type === SECTION_TYPES.accessories) && <div className='status__options'>
            <h3>{t(type === SECTION_TYPES.invoices ? 'invoices' : 'magBoxAccessories')}</h3>
          </div>}
        </div>

        <div className='menu__full'>
          {goodbye !== 0 && <div
            className='menu__goodbye'
            style={{
              transform: `scale(${goodbye})`,
              marginTop: `${goodbye - 1}em`,
              padding: `${goodbye}em`
            }}>
            {t('back')}
          </div>}

          {(() => {
            switch (type) {
              case SECTION_TYPES.invoices: return <div className='account menu__section'>
                <Invoices onlyBody />
              </div>
              case SECTION_TYPES.history: return <MagHistory id={id} full ref={listRef} />
              case SECTION_TYPES.details: return <MagDetails ref={listRef} />
              case SECTION_TYPES.accessories: return <MagAccessories />
              case SECTION_TYPES.termination: return <MagResignation />
              case SECTION_TYPES.extension: return <RentalExtension />
              case SECTION_TYPES.cancel: return <MagCancel />
              default: return <MagAccess full ref={listRef} />
            }
          })()}
        </div>
      </div>
    </div>
  )
}

export default SubMenu